import { createContext } from 'react';

export interface ListingContextProps {
    theme: 'mod1' | null;
    isPremium: boolean;
    hasProducts: boolean;
}

export default createContext<ListingContextProps>({
    theme: null,
    isPremium: false,
    hasProducts: false,
} as ListingContextProps);
